import { TDevice } from '../components/analytics/types';

const DESKTOP: TDevice = 'desktop';
const MOBILE: TDevice = 'mobile';
const ALL: TDevice = 'all';
const TABLET: TDevice = 'tablet';

export { DESKTOP, MOBILE, ALL, TABLET };
